// dayjs简写周几映射
export const handleWeekText = week => {
  switch (week) {
    case 'Mo':
      return '星期一'
    case 'Tu':
      return '星期二'
    case 'We':
      return '星期三'
    case 'Th':
      return '星期四'
    case 'Fr':
      return '星期五'
    case 'Sa':
      return '星期六'
    case 'Su':
      return '星期天'
  }
}



// WEBPACK FOOTER //
// ./src/pages/reportJs.js